/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedUsersForDiscover.defs'
export { main as default } from './getSuggestedUsersForDiscover.defs'
